import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

const AddWalletDialog = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [selectedOption, setSelectedOption] = useState("credit-debit-card");
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const handleContinue = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog(selectedOption);
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="wallet" />
                </div>
                <h1>{tLang("identityVault.secureStorage.lostWallterWidget.addToWalletPopup.title")}</h1>
            </div>

            <div className="dialog-body">
                <div className="form-row row">
                    <div className="form-label col-xs-12 col-no-gutter">
                        <label htmlFor="choose-wallet-item">
                            {tLang("identityVault.secureStorage.lostWallterWidget.addToWalletPopup.label")}{" "}
                            <span className="required" title="Mandatory" aria-hidden="true">
                                *
                            </span>
                        </label>
                    </div>
                    <div className="form-input col-xs-12 col-no-gutter">
                        <select id="choose-wallet-item" className="inputbox" value={selectedOption} onChange={(e) => setSelectedOption(e.currentTarget.value)} aria-required="true">
                            <option value="credit-debit-card">{tLang("identityVault.secureStorage.addWalletDropDownList.creditDebitCard")}</option>
                            <option value="bank-account">{tLang("identityVault.secureStorage.addWalletDropDownList.bankAccount")}</option>
                            {!isBusinessUser && <option value="drivers-license">{tLang("identityVault.secureStorage.addWalletDropDownList.driversLicense")}</option>}
                            {!isBusinessUser && <option value="medical-id-card">{tLang("identityVault.secureStorage.addWalletDropDownList.medicalIDCard")}</option>}
                            {!isBusinessUser && <option value="id-card">{tLang("identityVault.secureStorage.addWalletDropDownList.idCard")}</option>}
                            {!isBusinessUser && <option value="social-security-card">{tLang("identityVault.secureStorage.addWalletDropDownList.socialSecurityCard")}</option>}
                            <option value="passport">{tLang("identityVault.secureStorage.addWalletDropDownList.passport")}</option>
                            <option value="customer-rewards-card">{tLang("identityVault.secureStorage.addWalletDropDownList.customerRewardsCard")}</option>
                            <option value="combination">{tLang("identityVault.secureStorage.addWalletDropDownList.combination")}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                            <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.addToWalletPopup.cancelButtonText")}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={() => handleContinue()}>
                            <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.addToWalletPopup.continueButtonText")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddWalletDialog;
